import React from 'react'
import { Route, Switch } from 'react-router'
import PrivateRoute from './auth/components/PrivateRoute'

import { useMedia } from './hooks/useMedia'

import { MOBILE_SCREEN_WIDTH } from './constants'
import { PERMISSIONS } from './auth/constants'

import PalmettoDesktop from './screens/palmetto/MainLayout'
import PalmettoMobile from './screens/palmetto/MobileLayout'
import CommandCentralMobile from './screens/commandCentral/MobileLayout'
import CommandCentralDesktop from './screens/commandCentral/MainLayout'
import HCFRActiveIncidentsDesktop from './screens/hcfr/MainLayout'
import SignificantEventsDesktop from './screens/sigEvents/MainLayout'
import SignificantEventsMobile from './screens/sigEvents/MobileLayout'
import RoadClosuresDesktop from './screens/roadClosures/MainLayout'
import RoadClosuresMobile from './screens/roadClosures/MobileLayout'
import PowerOutagesDesktop from './screens/powerOutages/MainLayout'
import PowerOutagesMobile from './screens/powerOutages/MobileLayout'
import AdminLayoutDesktop from './screens/admin/MainLayout'
import AdminLayoutMobile from './screens/admin/MobileLayout'
import SitrepDesktop from './screens/sitrep/MainLayout'
import Login from './auth/components/Login'
import Landing from './screens/Landing'

const App = () => {
  const isDesktop = useMedia(`(min-width: ${MOBILE_SCREEN_WIDTH}px)`)

  if (isDesktop) {
    return (
      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute exact path="/" component={Landing} />
        <PrivateRoute
          path="/commandCentral"
          component={CommandCentralDesktop}
        />
        <PrivateRoute path="/hcfr" component={HCFRActiveIncidentsDesktop} />
        <PrivateRoute path="/sigevents" component={SignificantEventsDesktop} />
        <PrivateRoute path="/roadclosures" component={RoadClosuresDesktop} />
        <PrivateRoute path="/palmetto" component={PalmettoDesktop} />
        <PrivateRoute path="/powerOutages" component={PowerOutagesDesktop} />
        <PrivateRoute path="/sitrep" component={SitrepDesktop} />
        <PrivateRoute
          path="/admin"
          requiredPermissions={[PERMISSIONS.ADMIN]}
          component={AdminLayoutDesktop}
        />
      </Switch>
    )
  }
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <PrivateRoute exact path="/" component={Landing} />
      <PrivateRoute path="/commandCentral" component={CommandCentralMobile} />
      <PrivateRoute path="/hcfr" component={HCFRActiveIncidentsDesktop} />
      <PrivateRoute path="/palmetto" component={PalmettoMobile} />
      <PrivateRoute path="/roadClosures" component={RoadClosuresMobile} />
      <PrivateRoute path="/sigevents" component={SignificantEventsMobile} />
      <PrivateRoute path="/powerOutages" component={PowerOutagesMobile} />
      <PrivateRoute path="/sitrep" component={SitrepDesktop} />
      <PrivateRoute path="/admin" component={AdminLayoutMobile} />
    </Switch>
  )
}
export default App
